import { render } from "./RolesIndex.vue?vue&type=template&id=6f876796"
import script from "./RolesIndex.vue?vue&type=script&lang=js"
export * from "./RolesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__